import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { Roles } from 'src/app/shared/enums/Roles.enum';

interface LegalRepresentative {
  fullName: string;
  keynuaUrl: string;
}

@Component({
  selector: 'app-laft-company-keynua-qr',
  templateUrl: './laft-company-keynua-qr.component.html',
  styleUrls: ['./laft-company-keynua-qr.component.scss']
})
export class LaftCompanyKeynuaQrComponent implements OnInit {
  @Output() explorePlatformEvent = new EventEmitter<void>();
  
  legalRepresentatives: LegalRepresentative[] = [];

  constructor(
    public dialogRef: MatDialogRef<LaftCompanyKeynuaQrComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard
  ) { }

  ngOnInit(): void {
    if (this.data?.legalRepresentatives) {
      this.legalRepresentatives = this.data.legalRepresentatives;
    }
  }

  goToKeynua(url: string): void {
    // Open Keynua URL in a new tab
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.location.href = url;
    }
  }

  copyLink(url: string, event: Event): void {
    event.preventDefault();
    this.clipboard.copy(url);
  }

  explorePlatform(): void {
    this.dialogRef.close();
    this.explorePlatformEvent.emit();
  }

  get isClient(): boolean {
    return this.data?.user?.role === Roles.CLIENT;
  }
}
